import { useCallback } from 'react';
import { useNavigate as useNavigateRouter, useLocation } from 'react-router-dom';
import { getRoute } from '../components/Surveys/utils/getRoute';

type NavigateFunc = (
  route: string,
  routeParams: Record<string, string | number | boolean>,
  preserveSearch?: boolean,
) => void;

export const useNavigate = (): NavigateFunc => {
  const navigate = useNavigateRouter();
  const location = useLocation();

  return useCallback(
    (
      route: string,
      routeParams: Record<string, string | number | boolean>,
      preserveSearch?: boolean,
    ) => {
      navigate(getRoute(route, routeParams, preserveSearch === true ? location.search : undefined));
    },
    [navigate, location],
  );
};
